import React,{useEffect} from 'react';
import Styles from './Header.module.scss';
import logo from "../../images/home_logo.gif";
import { leftMenu, rightMenu } from "../../constants/menu"
import classnames from 'classnames';

interface HeaderProps {
    theme: string;
    route: string;
}
const Header = ({ theme, route }: HeaderProps) => {



    return (
        <div className={Styles.header}>
            <div className={Styles.logo}>
                <img src={logo} />
            </div>
            <div className={Styles.menus}>
                <div className={Styles.menu_left}>
                    {
                        leftMenu.map((menuItem: any) => {
                            return (
                                <div key={menuItem.link} className={Styles.menu_item_container} >
                                    <a href={`/#${menuItem.link}`} className={classnames(Styles.left,Styles.menu_item)} >{menuItem.label}</a>
                                </div>
                            )
                        })
                    }
                </div>
                <div className={Styles.menu_right}>
                    {
                        rightMenu.map((menuItem: any) => {
                            return (
                                <div key={menuItem.link} className={route === menuItem.link ? Styles.active_menu : Styles.menu_item_container} >
                                    <a href={`/${menuItem.link}`} className={Styles.menu_item} >{menuItem.label}</a>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Header;

